import { createAirbrakeNotifier } from "./airbrakeNotifier";
import { createConsoleNotifier } from "./consoleNotifier";
import { IErrorNotifier } from "./types";

function createErrorNotifier(appName: string): IErrorNotifier {
  return createAirbrakeNotifier(appName) ?? createConsoleNotifier();
}

export { createErrorNotifier, type IErrorNotifier };
